import React from 'react';
import TimeTableInput from "./timeTableInput";

export default function TimetableClassEditor({ timetable, onTimetableChange, dayLabels = [], dayShortNames = [], timeUnits = [] }) {
    const handleTimetableChange = (oldValue, newValue, timeUnitIndex, dayIndex) => {
        if(onTimetableChange && typeof onTimetableChange === 'function') {
            // Convert from TimeTableInput format to column/row format
            onTimetableChange(dayIndex, timeUnitIndex, newValue);
        }
    };

    // If timetable is a matrix of columns x rows, derive number of rows and cols
    const numCols = Array.isArray(timetable) ? timetable.length : 0;
    const numRows = numCols > 0 && Array.isArray(timetable[0]) ? timetable[0].length : 0;

    return (
        <div className="overflow-x-auto w-full">
            <table className="min-w-full text-base" style={{ borderCollapse: 'separate', borderSpacing: '4px 0px' }}>
                <thead>
                    <tr>
                        <th className="py-1 max-w-[64px]"></th>
                        {Array.from({ length: numCols }).map((_, colIndex) => (
                            <th key={colIndex} className="py-1 w-[110px] font-bold text-center border-b border-gray-600">
                                <span className="hidden md:inline">{dayLabels[colIndex] || `Tag ${colIndex + 1}`}</span>
                                <span className="md:hidden">{dayShortNames[colIndex] || `Tag ${colIndex + 1}`}</span>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: numRows }).map((_, rowIndex) => {
                        const timeUnit = timeUnits.find(unit => unit.index === rowIndex);
                        
                        return (
                            <tr key={rowIndex} className="h-[64px]">
                                <td className="py-1 w-[64px] text-sm md:text-md font-bold text-left bg-white align-middle">
                                    <span className="hidden md:inline">{timeUnit ? `${timeUnit.startTime} - ${timeUnit.endTime}` : `Einheit ${rowIndex+1}`}</span>
                                    <span className="md:hidden">{timeUnit ? timeUnit.startTime : ''} <br />{timeUnit ? timeUnit.endTime : ''}</span>
                                </td>
                                
                                {Array.from({ length: numCols }).map((_, colIndex) => {
                                    const cell = (timetable[colIndex] && timetable[colIndex][rowIndex]) || '';
                                    
                                    // Get neighbor values for visual styling
                                    const leftCell = colIndex > 0 ? (timetable[colIndex-1] && timetable[colIndex-1][rowIndex]) || '' : null;
                                    const rightCell = colIndex < numCols - 1 ? (timetable[colIndex+1] && timetable[colIndex+1][rowIndex]) || '' : null;
                                    const topCell = rowIndex > 0 ? (timetable[colIndex] && timetable[colIndex][rowIndex-1]) || '' : null;
                                    const bottomCell = rowIndex < numRows - 1 ? (timetable[colIndex] && timetable[colIndex][rowIndex+1]) || '' : null;
                                    
                                    return (
                                        <td key={`${colIndex}-${rowIndex}`} className="relative min-w-[64px] h-full p-0">
                                            <TimeTableInput
                                                data={cell}
                                                editable={true}
                                                dataLeft={null} // ignore left neighbor
                                                dataRight={null} // ignore right neighbor
                                                dataTop={topCell}
                                                dataBottom={bottomCell}
                                                timeUnitIndex={rowIndex}
                                                dayIndex={colIndex}
                                                onChange={handleTimetableChange}
                                            />
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}